import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { ILayout } from "../../common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "../../core/components/FragmentLayout";
import { FragmentProvider } from "../../core/components/FragmentProvider";
import * as fragments from "./fragments";

const certificateFragments = FragmentProvider.getLayoutInput(fragments);

@Form({ title: "Certificates Panel Config" })
export class CertificatesPanelConfig {

	@Input({type: InputType.JSON, title: "Certificate Params"})
	public certificateParams: object;

	@Input({ type: InputType.CHECKBOX, title: "Enable Refine Panel" })
	public enableRefine?: boolean;

	@Input({ type: InputType.CHECKBOX, title: "Enable Load More" })
	public enableLoadMore?: boolean;

	@Input({ type: InputType.NUMBER, title: "Default Page Size" })
	public pageSize?: number;

	@Input({type: certificateFragments, title: "Card Layout"})
	public itemLayout: ILayout<IFragmentLayoutConfig>;

}



// WEBPACK FOOTER //
// ./src/panels/certificates/CertificatesConfig.ts